import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { getLawInterfaceFromStorage } from 'CorePackage/MainModule/common/getLawInterfaceFromStorage';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';

import { ISimilaritiesFilter } from '../interfaces/ISimilaritiesFilter';
import { ISimilaritiesResponse } from '../interfaces/ISimilaritiesResponse';
import { IExport } from '../../ImportExportModule/interfaces/IExport';
import { ISimilarityStatusEnum } from '../interfaces/ISimilarityStatus';
import { ISimilaritiesMatchByPersonFilter } from '../interfaces/ISimilaritiesMatchByPersonFilter';
import { ISimilarityMatch } from '../interfaces/ISimilarityMatch';
import { ExportSimilaritiesListTypesEnum } from '../enums/ExportSimilaritiesListTypesEnum';

export async function fetchSimilarities(
  filters: ISimilaritiesFilter,
  page = 0,
  order = '',
  size = 50,
): Promise<ISimilaritiesResponse> {
  const params = new URLSearchParams();

  params.append('page', String(page));
  params.append('size', String(size));
  order && params.append('order', order);

  return apiPost<ISimilaritiesResponse>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/match?${params}`,
    body: filters,
  });
}

export async function exportSimilarities(format: ExportFormatsEnum, filters: ISimilaritiesFilter): Promise<IExport> {
  const lawInterface = getLawInterfaceFromStorage();
  const params = new URLSearchParams();

  params.set('format', format);
  params.set('isFederalLaw248', String(lawInterface === LawInterfacesEnum.FZ_248));

  return apiPost<IExport>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/match/export?${params}`,
    body: filters,
  });
}

export async function exportSimilaritiesInKnmList(
  id: string,
  format: ExportFormatsEnum,
  type: ExportSimilaritiesListTypesEnum,
): Promise<IExport> {
  const lawInterface = getLawInterfaceFromStorage();
  const params = new URLSearchParams();

  params.set('format', format);
  params.set('type', type);
  params.set('isFederalLaw248', String(lawInterface === LawInterfacesEnum.FZ_248));

  return apiPost<IExport>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/match/export/by-knm/${id}?${params}`,
  });
}

export async function exportSimilaritiesFromImportByPlanId(
  id: string,
  format: ExportFormatsEnum,
  type: 'KNM_MATCH_BY_PLAN_ALL' | 'KNM_MATCH_BY_PLAN',
): Promise<IExport> {
  const lawInterface = getLawInterfaceFromStorage();
  const params = new URLSearchParams();

  params.set('format', format);
  params.set('type', type);
  params.set('isFederalLaw248', String(lawInterface === LawInterfacesEnum.FZ_248));

  return apiPost<IExport>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/match/export/by-plan/${id}?${params}`,
  });
}

export async function exportSimilaritiesById(
  format: ExportFormatsEnum,
  id: string,
  filters: ISimilaritiesMatchByPersonFilter,
): Promise<IExport> {
  const lawInterface = getLawInterfaceFromStorage();
  const params = new URLSearchParams();

  params.set('format', format);
  params.set('isFederalLaw248', String(lawInterface === LawInterfacesEnum.FZ_248));

  return apiPost<IExport>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/match/export/${id}?${params}`,
    body: filters,
  });
}

export async function changeStatusSimilarities(
  status: ISimilarityStatusEnum,
  id: string,
  startDate?: string,
  filters?: ISimilaritiesFilter,
): Promise<ISimilaritiesResponse> {
  return apiPost<ISimilaritiesResponse>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/match/${id}?status=${status}${
      startDate ? `&startDate=${startDate}` : ''
    }`,
    body: filters,
  });
}

export async function fetchSimilaritiesById(
  id: string,
  order: string,
  filters?: ISimilaritiesMatchByPersonFilter,
): Promise<ISimilarityMatch[]> {
  return apiPost<ISimilarityMatch[]>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/match/by-person/${id}${order ? `?order=${order}` : ''}`,
    body: filters,
  });
}

export async function getSimilaritiesStatus(): Promise<ISimilarityStatusEnum> {
  return apiGet<ISimilarityStatusEnum>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/match/statuses`);
}
